module.exports = __webpack_public_path__ + "img/info1-bg.603c6141.svg";